
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44.88 47.32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.54 37.37V14a1.86 1.86 0 00-3.72 0v23.37a1.86 1.86 0 003.72 0zm-8.48 0V14a1.87 1.87 0 00-3.73 0v23.37a1.87 1.87 0 003.73 0zm16.82-25.2A1.86 1.86 0 0033 14v28.22a1.37 1.37 0 01-1.37 1.37H9.23a1.37 1.37 0 01-1.37-1.37V14a1.87 1.87 0 00-3.73 0v28.22a5.11 5.11 0 005.1 5.1h22.42a5.1 5.1 0 005.09-5.1V14a1.85 1.85 0 00-1.86-1.83zM39 6.37h-8.41V1.86A1.87 1.87 0 0028.72 0H12.15a1.86 1.86 0 00-1.86 1.86v4.51H1.86a1.86 1.86 0 000 3.72H39a1.86 1.86 0 000-3.72zm-12.16 0H14V3.72h12.86v2.65z","fill":"#515358"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/delete.svg